import { QueryClient } from "@tanstack/react-query";
import { retryUpTo } from "./requestFailure";

/**
 * How long a query result counts as fresh unless the query sets its own
 * `staleTime`. Without it every window focus and every remount re-requested
 * each query in view (the Statistics page alone fires six heavy aggregates).
 * Polling (`refetchInterval`) and invalidation after writes ignore it, and
 * queries whose UI needs tighter freshness declare their own `staleTime`.
 */
export const DASHBOARD_DEFAULT_STALE_TIME_MS = 30_000;

/**
 * The dashboard's QueryClient and its app-wide query defaults. A failed query
 * is retried once only when it may heal (network, 5xx, 408, 429); a 401, 403,
 * 404 or other 4xx answers the same way on every attempt.
 */
export function createDashboardQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DASHBOARD_DEFAULT_STALE_TIME_MS,
        refetchOnWindowFocus: true,
        retry: retryUpTo(1),
      },
    },
  });
}
